module.exports = __webpack_public_path__ + "img/2_277.b4dd71e3.png";